// Shared logic for recovering from a stale JS/CSS chunk after a new deploy
// renamed or removed the file a user's already-loaded page still references.
// Used by main.tsx (vite:preloadError listener), the top-level error
// boundary in App.tsx, and DashboardErrorBoundary — one place to detect the
// error and one guarded reload so all three stay in sync.

const RELOAD_GUARD_KEY = "chunk-reload-attempted";

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error);
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("Loading chunk") ||
    message.includes("ChunkLoadError")
  );
};

// Reloads at most once per session — if the same failure happens again right
// after, the page is left to show its normal error fallback instead of
// looping forever (e.g. if the server is genuinely down).
export const reloadOnceForStaleChunk = (): boolean => {
  if (sessionStorage.getItem(RELOAD_GUARD_KEY)) return false;
  sessionStorage.setItem(RELOAD_GUARD_KEY, "true");
  window.location.reload();
  return true;
};

export const clearStaleChunkReloadGuard = (): void => {
  sessionStorage.removeItem(RELOAD_GUARD_KEY);
};
